import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center justify-center">
      <img 
        src="/berrys-logo.svg" 
        alt="Berrys Logo" 
        className="h-6 w-auto"
      />
    </div>
  );
};

export default Logo;

